<template>
    <div id="boxReagendar"> 
        <h3>Reagendar/ Aguardando Retorno/ Devolver Ficha</h3>
        <input type="text" placeholder="Pesquisar em Reagendar/ Devolver Ficha" v-model="filtro" class="form-control"> <br /> 
        <table class="table table-striped table-bordered">
          <thead> 
            <tr> 
              <td>Ficha Aprov.</td>
              <td>Nome</td>
              <td>CPF</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item of filteredData">
              <td> {{ item.IdFichaAprovacao }} </td>
              <td class="text-left"> {{ item.Nome }} </td>
              <td> {{ item.Cpf }} </td>
              <td> <input type="checkbox" title="Selecionar" :value="item" v-model="selecionados" /> </td>  
            </tr>
            <tr  v-if="items.length == 0">
              <td colspan="4">Não há resultados para exibir</td>
            </tr>
          </tbody>
          <tfoot> 
            <tr v-show="acessoBotoes">
              <td colspan="4" class="text-right"> 
                <button type="button" class="btn btn-primary" title="Iniciar Atendimento" @click="fazerAtendimento" :disabled="habilitarBotoes"> 
                  <i class="fa fa-user" aria-hidden="true"  v-show="!loadAtendimento" ></i>  
              <i class="fa fa-circle-o-notch fa-spin" v-show="loadAtendimento"></i> 
                </button> 
                <button type="button" class="btn btn-primary" title="Devolver Ficha de Aprovação" @click="devolverFicha" :disabled="habilitarBotoes"> <i class="fa fa-undo" aria-hidden="true"></i> </button>  
                <button type="button" class="btn btn-danger" title="Remover/Finalizar" @click="removerFinalizar" :disabled="habilitarBotoes"> <i class="fa fa-remove" aria-hidden="true"></i> </button>  
              </td>
            </tr>
          </tfoot>
        </table> 
    </div>
</template>
<script>
export default{
  name: 'Reagendar',
  components: {
  },
  created () {
    this.listar()
  },
  computed: {
    habilitarBotoes () {
      return this.selecionados.length === 0
    },
    filteredData: function () {
      var filtro = this.filtro && this.filtro.toLowerCase()
      var data = this.items
      if (filtro) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filtro) > -1
          })
        })
      }
      return data
    }
  },
  methods: {
    listar () {
      this.$http.get('reagendar?dia=' + this.dia + '&unidade=' + parseInt(localStorage.getItem('Unidade')))
      .then(function (res) {
        this.items = res.body
        this.loadRemover = false
        this.loadDevolver = false
      })
      .catch(function (err) {
        this.loadRemover = false
        console.log(err)
        this.loadRemover = false
        this.loadDevolver = false
      })
    },
    fazerAtendimento () {
      if (this.selecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      this.loadAtendimento = true
      let agendamentovm = {
        agendamento: this.selecionados,
        Status: 1,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }
      this.$http.put('atualizar-status', agendamentovm)
      .then(function (res) {
        location.reload()
      })
      .catch(function (err) {
        this.loadAtendimento = false
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    },
    removerFinalizar () {
      if (this.selecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      this.loadRemover = true
      let agendamentovm = {
        agendamento: this.selecionados,
        Status: 7,
        coletivo: false,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }

      this.$http.put('atualizar-status', agendamentovm)
      .then(function (res) {
        this.listar()
        this.selecionados = []
      })
      .catch(function (err) {
        this.loadRemover = false
        alert('Ocorreu um erro ao Remover da lista')
        console.log(err)
      })
    },
    devolverFicha () {
      if (this.selecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return
      }
      this.loadDevolver = true
      let agendamentovm = {
        agendamento: this.selecionados,
        Status: 3,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }
      this.$http.post('devolver', agendamentovm)
      .then(function (res) {
        alert('Ficha devolvida com sucesso')
        location.reload()
      })
      .catch(function (err) {
        this.loadDevolver = false
        alert('Ocorreu um erro ao Devolver a Ficha')
        console.log(err)
      })
    }
  },
  props: ['data', 'filial', 'acessoBotoes'],
  data () {
    return {
      filtro: '',
      items: [],
      dia: this.data,
      selecionados: [],
      loadDevolver: false,
      loadRemover: false,
      loadAtendimento: false
    }
  }
}
</script>
<style scoped> 
    #boxReagendar{  
      width:100%;
      background: #fff;
    }
    #boxReagendar h3{
      padding: 15px 0;
      background: #23527b;
      color:#fff;
    }
    #boxReagendar thead td{
    padding: 8px 0;
    background: #2d618e;
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    }
    #boxReagendar table td {
      border-color:#fff;
    }
    #boxReagendar tfoot td{ 
    background: #cacaca;
    color: #fff; 
    }
</style>



// WEBPACK FOOTER //
// Reagendar.vue?35e7ce6f